<div style="display: flex; align-items: center; justify-content: center;" *ngIf="loadingQuotes || loadingRecipients">
  <mat-spinner diameter="48"></mat-spinner>
</div>
<div *ngIf="!loadingQuotes && !loadingRecipients">
  <h4>{{'Send Report' | translate | async}} </h4>
  <div class="select-quote-container">
    <!-- <mat-form-field>
      <mat-select placeholder="Select Quote" [(ngModel)]="selectedQuoteId" name="Quote">
        <mat-option *ngFor="let q of quotes; let i = index" [value]="q.QuoteId">
          Quote {{i + 1}}
        </mat-option>
      </mat-select>
    </mat-form-field> -->
    
  </div>
  
    <mat-checkbox  *ngIf="selectedTemperatureId>0" (change)="toggleIncludeTemperatureReport($event)">{{'Include Temperature Inspection' | translate | async}} </mat-checkbox>
  <!--<mat-form-field>
    <textarea matInput placeholder="Quote Comment" rows="4"></textarea>
  </mat-form-field>-->
  <div style="display: flex; flex-direction: column;">
    <div class="recipient-container mat-checkbox-normal" style="overflow-x: auto;">
      <div><span class="select-recipients">{{'Select Email Recipients' | translate | async}}</span><span class="add-recipient" (click)="onAddRecipientClick()">{{'Add Recipient' | translate | async}} </span></div>
      <mat-checkbox (change)="recipientClicked($event, recipient.Email, recipient.Name)" *ngFor="let recipient of recipients" [checked]="true">{{recipient.DecryptedName}} (<a href="mailto:{{recipient.DecryptedEmail}}">{{recipient.DecryptedEmail}}</a>)</mat-checkbox>
    </div>
    <div >
      <h4>{{'Send Options' | translate | async}}  
        <!-- <mat-icon class="info-icon">info</mat-icon> -->
      </h4>
      <div class="send-options-container">
        <div style="display: flex; align-items: center;">
           <mat-checkbox (change)="toggleIncludeQuoteReport($event)">{{'Include Quote' | translate | async}} </mat-checkbox>
          <div class="recommendation-pill" matTooltip="Recommendations included in this quote">
          {{recommendationCount}} {{'Recommendation' | translate | async}} {{recommendationCount != 1 ? 's' : ''}}
    </div>
        </div>
      <!-- <mat-checkbox (change)="SendReportImmediately($event)"> Send Immediately</mat-checkbox> -->
</div>
    </div>


    <div class="button-container">
      <button mat-raised-button (click)="onCancelClick()">{{'Cancel' | translate | async}} </button>
       <button mat-raised-button color="warn"  (click)="onSendClick()" [class.loading]="sendingReport">{{'Send' | translate | async}} </button>
      <!-- <button mat-raised-button color="warn" *ngIf="!sendReportImmediately" (click)="onSendClick()" [class.loading]="sendingReport">{{'Send to Queue' | translate | async}} </button> -->
    </div>
  </div>
  
</div>
